/**
 *
 * ActionTrigger
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import IconButton from 'components/interaction/IconButton/index.jsx';

function ActionTrigger(props) {
  const { onDelete, onRotate } = props;
  return (
    <>
      { onDelete && <IconButton icon="ss-trash" variant="light" size="sm" className="text-danger position-absolute top-0 start-0 m-1" onClick={onDelete} /> }
      { onRotate && <IconButton icon="ss-refresh" variant="light" size="sm" className="text-primary position-absolute top-0 end-0 m-1" onClick={onRotate} /> }
    </>
  );
}

ActionTrigger.propTypes = {
  onDelete: PropTypes.func,
  onRotate: PropTypes.func,
};

export default ActionTrigger;
